import { Badge } from 'braid-design-system';

/**
 * Badge indicating that some guidance is still early and directional.
 */
export const Directional = () => (
  <Badge tone="info" weight="strong">
    Directional
  </Badge>
);
